import {
	Air,
	AltRoute,
	BubbleChart,
	BubbleChartOutlined,
	Router,
	RouterOutlined,
	DeviceThermostat,
} from '@mui/icons-material'
import { GiValve } from 'react-icons/gi'
import React, { PropsWithChildren } from 'react'
import { defaultProps } from 'recompose'
import { MachineCategory, StepRate } from '../../types'
import {
	Curtain1,
	Curtain2,
	Curtain3,
	Curtain4,
	Curtain5,
	CurtainOff,
	CurtainOn,
	HeaterOff,
	HeaterOn,
	MistOff,
	MistOn,
	Window1,
	Window2,
	Window3,
	Window4,
	Window5,
	WindowOff,
	WindowOn,
} from './IconsSet'

const CURTAIN_ICONS_MAP = [
	CurtainOff,
	Curtain1,
	Curtain2,
	Curtain3,
	Curtain4,
	Curtain5,
	CurtainOn,
]
const WINDOW_ICONS_MAP = [
	WindowOff,
	Window1,
	Window2,
	Window3,
	Window4,
	Window5,
	WindowOn,
]

const withGrayFont = defaultProps({ className: 'off-icon' })
const FanOff = withGrayFont(Air)
const Co2Off = withGrayFont(BubbleChartOutlined)
const RouterOff = withGrayFont(RouterOutlined)
const HpOff = withGrayFont(DeviceThermostat)
const TwayOff = withGrayFont(AltRoute)
// react-icons の IconType は React18/19 型前提のため、React17 型の当リポジトリでは any で受ける
const DenjiIcon = GiValve as unknown as React.ComponentType<any>
const DenjiOff = withGrayFont(DenjiIcon)

export function machineCategoryIcon(
	category: MachineCategory,
	stepRate: StepRate,
) {
	switch (category) {
		case 'window':
			return WINDOW_ICONS_MAP[stepRate]
		case 'curtain':
			return CURTAIN_ICONS_MAP[stepRate]
		case 'fan':
			return stepRate === 0 ? FanOff : Air
		case 'heating':
			return stepRate === 0 ? HeaterOff : HeaterOn
		case 'mist':
			return stepRate === 0 ? MistOff : MistOn
		case 'co2':
			return stepRate === 0 ? Co2Off : BubbleChart
		case 'hp':
			return stepRate === 0 ? HpOff : DeviceThermostat
		case 'tway':
			return stepRate === 0 ? TwayOff : AltRoute
		case 'denji':
			return stepRate === 0 ? DenjiOff : DenjiIcon
		default:
			return stepRate === 0 ? RouterOff : Router
	}
}

type IconProps = PropsWithChildren<{
	category: MachineCategory
	stepRate: StepRate
	style?: React.CSSProperties
}>
export function CategoryIcon({ category, stepRate, ...props }: IconProps) {
	const Icon = machineCategoryIcon(category, stepRate)

	return <Icon {...props} />
}

CategoryIcon.defaultProps = {
	stepRate: 6,
}
